/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Dropdown, type DropdownProps } from '@mairistem/composants';
import { Liste, ListeQueryContext } from '@mairistem/liste';

import type { TypeActe } from '@/types';
import type { Pacs } from '@/types/Pacs';
import { TYPES_ACTES_IMPLEMENTES, TYPES_ACTES_OPTIONS } from '@/constants';
import ActeListeTable from './ActeListeTable';

interface ActeListeProps {
  pacs?: Array<Pacs>;
  count?: number;
  perPage?: number;
  loading?: boolean;
  onLoad?: any;
  onSearch?: any;
  onSort?: any;
  onExplored?: any;
  onExpanded?: any;
  state?: any;
  mode?: 'expander' | 'explorer';
  dashboard?: boolean;
  modal?: boolean;
  stats?: boolean;
  assistant?: boolean;
  typeActe?: string;
  onSelect?: (item: Partial<Pacs>) => void;
}

// Les mentions ne sont pas dans les dropdowns puisque pas afficher dans les listes directement.
// Ni les pacs ni les décisions, réservés à la v2 de l'application.
const TYPES_ACTES_LISTE_OPTIONS = TYPES_ACTES_OPTIONS.filter(
  ({ key }) =>
    key === 'all' || TYPES_ACTES_IMPLEMENTES.includes(key as TypeActe),
);

const ActeListe = (props: ActeListeProps) => {
  const {
    pacs,
    count,
    perPage,
    loading,
    onLoad,
    onSort,
    mode,
    dashboard,
    modal,
    stats,
    assistant,
    typeActe,
    onSelect,
    ...handlers
  } = props;

  const { filterQuery } = React.useContext(ListeQueryContext);

  const handleTypeChange = (
    _e: React.SyntheticEvent,
    { value }: DropdownProps,
  ) => {
    if (value) {
      filterQuery({ type_acte: value });
    } else {
      filterQuery({});
    }
  };

  return (
    <Liste
      title={!assistant && !dashboard && !modal ? 'Liste des actes' : ''}
      mode={mode}
      searchable
      search={{
        clearable: true,
        placeholder: "Saisir le nom d'une personne...",
      }}
      {...handlers}
    >
      <Liste.Header style={{ justifyContent: 'flex-end', paddingRight: 0 }}>
        {!stats && (
          <Dropdown
            selection
            options={TYPES_ACTES_LISTE_OPTIONS}
            defaultValue=""
            placeholder="Tous les types"
            style={{ minWidth: '12em' }}
            onChange={handleTypeChange}
          />
        )}
      </Liste.Header>
      <Liste.Content>
        <ActeListeTable
          mode={mode}
          items={pacs}
          loading={loading}
          count={count}
          perPage={perPage}
          onLoad={onLoad}
          onSort={onSort}
          dashboard={dashboard}
          typeActe={typeActe}
          assistant={assistant}
          onSelect={onSelect}
        />
      </Liste.Content>
    </Liste>
  );
};

export default ActeListe;
